import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import type { Certification } from '../types';

interface CertificationBadgesProps {
  certifications: Certification[];
}

const CertificationBadges = ({ certifications }: CertificationBadgesProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-primary">{t('footer.sections.certs')}</h3>
      <div className="grid grid-cols-2 gap-3">
        {certifications.map((cert, index) => (
          <div
            key={index}
            className="p-4 rounded-lg bg-surface border border-border hover:border-accent/50 transition-all duration-300 group"
          >
            <div className="flex flex-col items-center text-center gap-2">
              <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center group-hover:scale-110 transition-transform">
                <Icon name={cert.icon} size={24} className="text-accent" />
              </div>
              <div>
                <p className="text-sm font-medium text-primary">{cert.name}</p>
                <p className="text-xs text-secondary mt-1">{cert.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CertificationBadges;